import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=2f0cf222&scoped=true"
import script from "./addShop.vue?vue&type=script&lang=js"
export * from "./addShop.vue?vue&type=script&lang=js"
import style0 from "./addShop.vue?vue&type=style&index=0&id=2f0cf222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cf222",
  null
  
)

export default component.exports